import { Component, Inject, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Profile } from '@app/profile/profile.model';

import { AuthService, TrackerService } from '@dg/shared-services';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';
import {
  ProfileSocialModalFacade,
  SocialModalVM,
  StatusVM,
} from '@app/profile/components/profile-header/profile-social-modal/profile-social-modal.facade';
import { Observable } from 'rxjs';
import { FollowUser } from '@app/profile/components/profile-header/profile-social-modal/profile-social-modal.facade';
import { ProfileService } from '@app/profile/services/profile.service';
import { WindowToken } from '@app/shared/window.token';
import { UserProfile } from '@app/user/user-api.model';

@Component({
  selector: 'dgx-followers-tab',
  templateUrl: './followers-tab.component.html',
  styleUrls: ['../profile-social-modal.component.scss'],
})
export class FollowersTabComponent
  extends SubscriberBaseDirective
  implements OnInit
{
  @Input() public ownerIsViewing: boolean;
  @Input() public profile: Profile;

  public vm$: Observable<SocialModalVM>;
  public status$: Observable<StatusVM>;

  public authUserId: string;

  public i18n = this.translateService.instant([
    'UserController_ThisUserPrivate',
  ]);

  constructor(
    private translateService: TranslateService,
    private authService: AuthService,
    private profileSocialModalFacade: ProfileSocialModalFacade,
    private trackerService: TrackerService,
    private profileService: ProfileService,
    @Inject(WindowToken) private windowRef: Window
  ) {
    super();
  }

  public ngOnInit(): void {
    this.vm$ = this.profileSocialModalFacade.vm$;
    this.status$ = this.profileSocialModalFacade.status$;

    this.authUserId = this.authService.authUser.viewerProfile.userProfileId;

    this.profileSocialModalFacade.loadFollowers(this.profile.userProfileKey);

    this.trackerService.trackEventData({
      action: 'Followers Modal Viewed',
      properties: {
        UserId: this.profile.userProfileKey,
        ProfileType: this.profileService.getProfileType(),
        ActionLocation: this.profileService.profileLocation,
      },
    });
  }

  public goToProfile(profile: UserProfile): void {
    this.windowRef.location.href = `/profile/${profile.vanityUrl}/overview`;
  }

  public setFollowUser(
    response: { isActive: boolean },
    follower: FollowUser
  ): void {
    this.profileSocialModalFacade.setFollowUser(response, follower);
  }

  public isViewersFollowee(userId: string): boolean {
    return this.profileSocialModalFacade.isViewersFollowee(userId);
  }
}
